<template>
  <div class="te-bg-lp">
    <div class="mx-auto max-w-[560px]">
      <!-- カバー -->
      <section id="cover-02">
        <img
          class="w-full"
          src="~/assets/images/Te/TeLp/Sidejob/Aff1/cover.webp"
          alt="現役Webデザイナーが伴走し未経験からお仕事獲得を実現！"
          width="390"
          height="451"
          loading="lazy"
        >
      </section>

      <!-- CTA -->
      <section
        id="cta-02-firt"
        class="bg-[#EEFFFE]"
      >
        <div class="grid grid-cols-1 gap-6 px-5 py-8">
          <img
            class="mx-auto md:w-[84%]"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/cover-eye-catch.webp"
            alt="気になる点や不安を全て解消"
            width="350"
            height="54"
            loading="lazy"
          >
          <div>
            <a
              class="bot_open mb-4 block"
              href="/counseling/htmlcss-schedule#schedule"
            >
              <img
                class="te-btn-hover mx-auto md:w-[84%]"
                src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-btn.webp"
                alt="無料で相談する"
                width="330"
                height="64"
              >
            </a>
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cover-notes.webp"
              alt="無理な勧誘は一切ありません相談だけでもOK"
              width="244"
              height="18"
              loading="lazy"
            >
          </div>
        </div>
      </section>

      <!-- Example -->
      <section
        id="example"
        class="mx-auto bg-co-gray-50 px-8 py-12"
      >
        <h2 class="co-px-4 mb-12 sm:px-10">
          <img
            class="te-aff-h2-title mx-auto"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/h2-example.svg"
            alt="テックアカデミーだからできた未経験からWebデザイナーの夢を叶えた受講生"
            width="315"
            height="130"
            loading="lazy"
          >
        </h2>
        <img
          class="mb-5 w-full"
          src="~/assets/images/Te/TeLp/Sidejob/Aff1/case1.webp"
          alt="30代事務職からフリーランスのWebデザイナーに転身！"
          width="326"
          height="334"
          loading="lazy"
        >
        <img
          class="mb-5 w-full"
          src="~/assets/images/Te/TeLp/Sidejob/Aff1/case2.webp"
          alt="将来役に立つWeb制作スキルを身につけ副業の目標を達成！"
          width="326"
          height="310"
          loading="lazy"
        >
        <img
          class="mb-8 w-full"
          src="~/assets/images/Te/TeLp/Sidejob/Aff1/case3.webp"
          alt="育児をしながら学習し、Web制作の副業成功！"
          width="326"
          height="309"
          loading="lazy"
        >
        <img
          class="mb-8 w-full"
          src="~/assets/images/Te/TeLp/Sidejob/Aff1/number-of-peoples.webp"
          alt="受講者数10万人突破"
          width="330"
          height="209"
          loading="lazy"
        >
        <img
          class="w-full"
          src="~/assets/images/Te/TeLp/Sidejob/Aff1/media.webp"
          alt="有名メディアにも紹介されました"
          width="334"
          height="242"
          loading="lazy"
        >
      </section>

      <!-- CTA -->
      <section
        id="cta-02-second"
        class="bg-[#EEFFFE]"
      >
        <div class="grid grid-cols-1 gap-6 px-5 py-8">
          <h2 class="mb-0">
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-h2.webp"
              alt="カウンセラーと1対1で相談できる無料相談実施中！"
              width="243"
              height="62"
              loading="lazy"
            >
          </h2>
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-list-1.webp"
            alt="他のスクールとの違いやスクール選びのコツをご紹介"
            width="350"
            height="198"
            loading="lazy"
          >
          <div>
            <img
              class="mx-auto mb-2 md:w-[53%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-eye-catch.webp"
              alt="気になる点や不安を全て解消"
              width="209"
              height="25"
              loading="lazy"
            >
            <a
              class="bot_open mb-4 block"
              href="/counseling/htmlcss-schedule#schedule"
            >
              <img
                class="te-btn-hover mx-auto md:w-[84%]"
                src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-btn.webp"
                alt="無料で相談する"
                width="330"
                height="64"
              >
            </a>
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-notes.webp"
              alt="無理な勧誘は一切ありません相談だけでもOK"
              width="209"
              height="25"
              loading="lazy"
            >
          </div>
        </div>
      </section>

      <!-- スクール選びで失敗したくないですよね -->
      <section id="insecurity">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/insecurity-1.webp"
            alt="スクール選びで失敗したくないですよね"
            width="390"
            height="695"
          >
        </div>
      </section>

      <!-- Keys -->
      <section id="keys">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/keys.webp"
            alt="スクール選びで成功するための2つの軸"
            width="390"
            height="626"
          >
        </div>
      </section>

      <!-- メッセージ -->
      <section id="message">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/message-1.webp"
            alt="テックアカデミーなら成功のための2つの軸があるから安心してスタートできる！"
            width="390"
            height="244"
          >
        </div>
      </section>

      <!-- support -->
      <section id="learning-support">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/learning-support.webp"
            alt="未経験の方でも最後まで学びきれる3つのポイント"
            width="390"
            height="877"
          >
        </div>
      </section>

      <!-- Portfolio -->
      <section id="portfolio">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/portfolio.webp"
            alt="受講生が学習の中で作成した作品をご紹介"
            width="390"
            height="397"
          >
        </div>
      </section>

      <!-- CTA -->
      <section
        id="cta-02-third"
        class="bg-[#EEFFFE]"
      >
        <div class="grid grid-cols-1 gap-6 px-5 py-8">
          <h2 class="mb-0">
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-h2.webp"
              alt="カウンセラーと1対1で相談できる無料相談実施中！"
              width="243"
              height="62"
              loading="lazy"
            >
          </h2>
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-list-1.webp"
            alt="他のスクールとの違いやスクール選びのコツをご紹介"
            width="350"
            height="198"
            loading="lazy"
          >
          <div>
            <img
              class="mx-auto mb-2 md:w-[53%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-eye-catch.webp"
              alt="気になる点や不安を全て解消"
              width="209"
              height="25"
              loading="lazy"
            >
            <a
              class="bot_open mb-4 block"
              href="/counseling/htmlcss-schedule#schedule"
            >
              <img
                class="te-btn-hover mx-auto md:w-[84%]"
                src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-btn.webp"
                alt="無料で相談する"
                width="330"
                height="64"
              >
            </a>
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-notes.webp"
              alt="無理な勧誘は一切ありません相談だけでもOK"
              width="244"
              height="18"
              loading="lazy"
            >
          </div>
        </div>
      </section>

      <!-- point -->
      <section id="point">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/point.webp"
            alt="受講生が学習の中で作成した作品をご紹介"
            width="390"
            height="902"
          >
        </div>
      </section>

      <!-- Comment -->
      <section id="comment">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/comment.webp"
            alt="テックアカデミーを受講した方々の満足の声をご紹介"
            width="390"
            height="961"
          >
        </div>
      </section>

      <!-- flow -->
      <section id="flow">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/flow.webp"
            alt="副業までの流れをご紹介"
            width="390"
            height="1293"
          >
        </div>
      </section>

      <!-- リスキル補助金 -->
      <section id="flow">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/reskilling.webp"
            alt="副業までの流れをご紹介"
            width="390"
            height="565"
          >
        </div>
      </section>

      <!-- comparison -->
      <section id="comparison">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/comparison.webp"
            alt="他スクールとの比較"
            width="390"
            height="709"
          >
        </div>
      </section>

      <!-- メッセージ2 -->
      <section id="message2">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/message-2.webp"
            alt="他スクールとの比較"
            width="390"
            height="283"
          >
        </div>
      </section>

      <!-- 他にも気になることありますよね -->
      <section id="message-2">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/insecurity-2.webp"
            alt="他にも気になることありますよね"
            width="390"
            height="583"
          >
        </div>
      </section>

      <!-- CTA -->
      <section
        id="cta-02-fourth"
        class="bg-[#EEFFFE]"
      >
        <div class="grid grid-cols-1 gap-6 px-5 py-8">
          <h2 class="mb-0">
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-h2.webp"
              alt="カウンセラーと1対1で相談できる無料相談実施中！"
              width="243"
              height="62"
              loading="lazy"
            >
          </h2>
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-list-2.webp"
            alt="ゴールやご予算などご相談の上、最適なコースをご紹介"
            width="350"
            height="198"
            loading="lazy"
          >
          <div>
            <img
              class="mx-auto mb-2 md:w-[53%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-eye-catch.webp"
              alt="気になる点や不安を全て解消"
              width="209"
              height="25"
              loading="lazy"
            >
            <a
              class="bot_open mb-4 block"
              href="/counseling/htmlcss-schedule#schedule"
            >
              <img
                class="te-btn-hover mx-auto md:w-[84%]"
                src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-btn.webp"
                alt="無料で相談する"
                width="330"
                height="64"
              >
            </a>
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-notes.webp"
              alt="無理な勧誘は一切ありません相談だけでもOK"
              width="244"
              height="18"
              loading="lazy"
            >
          </div>
        </div>
      </section>

      <!-- reaction -->
      <section id="reaction">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/reaction.webp"
            alt="相談を受けて良かった！の声続出"
            width="390"
            height="602"
          >
        </div>
      </section>

      <!-- CTA -->
      <section
        id="cta-02-fifth"
        class="bg-[#EEFFFE]"
      >
        <div class="grid grid-cols-1 gap-6 px-5 py-8">
          <h2 class="mb-0">
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-h2.webp"
              alt="カウンセラーと1対1で相談できる無料相談実施中！"
              width="243"
              height="62"
              loading="lazy"
            >
          </h2>
          <img
            class="mx-auto w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-list-1.webp"
            alt="他のスクールとの違いやスクール選びのコツをご紹介"
            width="350"
            height="198"
            loading="lazy"
          >
          <div>
            <img
              class="mx-auto mb-2 md:w-[53%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-eye-catch.webp"
              alt="気になる点や不安を全て解消"
              width="209"
              height="25"
              loading="lazy"
            >
            <a
              class="bot_open mb-4 block"
              href="/counseling/htmlcss-schedule#schedule"
            >
              <img
                class="te-btn-hover mx-auto md:w-[84%]"
                src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-btn.webp"
                alt="無料で相談する"
                width="330"
                height="64"
              >
            </a>
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-notes.webp"
              alt="無理な勧誘は一切ありません相談だけでもOK"
              width="244"
              height="18"
              loading="lazy"
            >
          </div>
        </div>
      </section>

      <!-- FAQ -->
      <section id="faq">
        <div class="mx-auto bg-co-gray-50">
          <img
            class="w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/faq.webp"
            alt="よくある質問"
            width="390"
            height="685"
          >
        </div>
      </section>

      <!-- CTA -->
      <section
        id="cta-02-last"
        class="te-bg-cta-02 bg-cover"
      >
        <div class="mx-auto pb-5 sm:pb-12">
          <img
            class="relative top-[-12px] mb-5 w-full"
            src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-last-photo.webp"
            alt="まずは気軽に無料相談"
            width="390"
            height="323"
          >
          <div class="px-7">
            <img
              class="mx-auto md:w-[71%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-catch.webp"
              alt="テックアカデミーについてわからないことをなんでもご質問いただけます"
              width="280"
              height="46"
            >
            <a
              class="bot_open my-4 block"
              href="/counseling/htmlcss-schedule#schedule"
            >
              <img
                class="te-btn-hover mx-auto md:w-[84%]"
                src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-btn.webp"
                alt="無料で相談する"
                width="330"
                height="64"
              >
            </a>
            <img
              class="mx-auto md:w-[62%]"
              src="~/assets/images/Te/TeLp/Sidejob/Aff1/cta-notes-white.webp"
              alt="無理な勧誘は一切ありません相談だけでもOK"
              width="244"
              height="18"
            >
          </div>
        </div>
      </section>
    </div>

    <!-- 下部固定ボタン -->
    <TeLpSidejobAff1FixedBtn />
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'
import TeLpSidejobAff1Example from '~/components/Te/TeLp/Sidejob/Aff1/TeLpSidejobAff1Example.vue'
import TeLpSidejobAff1FixedBtn from '~/components/Te/TeLp/Sidejob/Aff1/TeLpSidejobAff1FixedBtn.vue'

const options = {
  async setup() {
    definePageMeta({
      layout: 'te-simple-lp'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'indexWithoutZendesk',
    })
    return {
      title:
        '未経験から在宅ワーク・副業・転職。プログラミングスクールならテックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              'プログラミングの副業、エンジニア転職やキャリアプランについて悩んでいる方へ。未経験の方や初心者の方などが持つ疑問・悩みを解消！現役プログラマーやデザイナーに体験談などを無料で聞ける。',
            twitterTitle:
              '未経験から在宅ワーク・副業・転職。プログラミングスクールならテックアカデミー',
            twitterDescription:
              'プログラミングの副業、エンジニア転職やキャリアプランについて悩んでいる方へ。未経験の方や初心者の方などが持つ疑問・悩みを解消！現役プログラマーやデザイナーに体験談などを無料で聞ける。',
            twitterImage: '/_nuxt/ogp/og-image.jpg',
            ogTitle:
              '未経験から在宅ワーク・副業・転職。プログラミングスクールならテックアカデミー',
            ogDescription:
              'プログラミングの副業、エンジニア転職やキャリアプランについて悩んでいる方へ。未経験の方や初心者の方などが持つ疑問・悩みを解消！現役プログラマーやデザイナーに体験談などを無料で聞ける。',
            ogUrl: '/lp/sidejob/aff-1',
            ogImage: '/_nuxt/ogp/og-image.jpg',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    TeLpSidejobAff1Example,
    TeLpSidejobAff1FixedBtn,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-lp {
  background-color: #e7f7f6;
}

.te-bg-aff-cover {
  padding-bottom: 80px;
  background-image: url('~/assets/images/Te/TeLp/Sidejob/Aff1/bg-cover.webp');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @media (min-width: 414px) {
    padding-bottom: 100px;
  }
  @media (min-width: 576px) {
    padding-bottom: 140px;
  }
}

.te-btn-hover:hover {
  opacity: 0.6;
  transition: all 0.5s ease;
}

.te-cta-btn-top-text {
  width: auto;
}

@media (min-width: 576px) {
  .te-cta-btn-top-text {
    width: 30rem;
    height: 2.875rem;
  }
}

.te-cover-btn {
  width: 76%;
}

.te-cover-badge {
  bottom: -1.5rem;
  z-index: 10;
}

.te-cover-badge .te-cover-badge-img {
  width: 65%;
}

/* セクション共通 */
.te-aff-h2-title {
  width: auto;
  @media (min-width: 576px) {
    width: 30rem;
  }
}

.te-aff-img {
  width: auto;
  @media (min-width: 576px) {
    width: 26.25rem;
  }
}

/* リスキル */
.te-bg-reskill {
  background-color: #aaf0e6;
}

.te-bg-cta {
  background-image: url('~/assets/images/Te/TeLp/Sidejob/Aff1/bg-cta.webp');
}

.te-cta-object {
  margin-top: -1.25rem;
}

.te-cta-btn-img {
  width: 76%;
}

/* おすすめコース */
.te-bg-aff-course-webdesign {
  background: #ffffe7;
}

.te-bg-aff-course-first-sidejob {
  background: #e9ffe8;
}

/* インセンティブ */
.te-bg-aff-incentive {
  background-color: #fb9e12;
}


/* 02 */
.te-bg-cta-02 {
  background-image: url('~/assets/images/Te/TeLp/Sidejob/Aff1/cta-bg.webp');
}

</style>
